import {Component, OnInit} from '@angular/core';
import {FiltersService} from "../../services/filters.service";
import {SortOrder} from "../../model/sort-order";
import {Audit} from "../../model/audit";
import {AuditsService} from "../../services/audits.service";
import {AuditFilters} from "../../model/filters/audit-filters";

@Component({
  selector: 'app-audits',
  templateUrl: './audits.component.html',
  styleUrls: ['./audits.component.scss']
})
export class AuditsComponent implements OnInit {

  public audits: Audit[];
  public totalAudits: number;
  public loadingAudits: boolean;

  public rows = 10;
  public first = 0;

  public currentFilters: AuditFilters;

  constructor(private auditsService: AuditsService,
              private filtersService: FiltersService<AuditFilters>) {
    this.currentFilters = new AuditFilters();
  }

  ngOnInit(): void {
    Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
    this.audits = new Array(this.rows);
  }

  private loadAudits(offset: number, limit: number): void {
    this.loadingAudits = true;
    this.audits = new Array(this.rows);
    this.trimFieldsForm(this.currentFilters);
    let cosa = this.filtersService.getCurrentFilters(this.constructor.name);
    this.auditsService.getAudits(offset, limit, this.filtersService.getCurrentFilters(this.constructor.name) === undefined ? this.currentFilters : this.filtersService.getCurrentFilters(this.constructor.name))
      .subscribe(response => {
        this.audits = response.audits;
        let dataKey = 0;
        this.audits.forEach(audit => {
          if (audit.oldValue) {
            audit.oldValue = JSON.parse(audit.oldValue);
          }
          if (audit.newValue) {
            audit.newValue = JSON.parse(audit.newValue);
          }
          audit['dataKey'] = dataKey++;
        });
        this.totalAudits = response.totalElements;
        this.loadingAudits = false;
      });
  }

  onPageChange(event): void {
    this.currentFilters.sortField = event.sortField;
    this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.loadAudits(event.first / event.rows, event.rows);
  }

  trimFieldsForm(filters: AuditFilters) {
    Object.keys(filters).forEach((key) => {
      if (filters[key] != undefined && typeof filters[key] === 'string') {
        filters[key] = filters[key].trim();
      }
    });
  }

}
